import { Gpu } from 'lucide-react';

import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';
import { Widget, WidgetBody, WidgetTitle } from '@/react/components/Widget';

import { LinkButton } from '@@/LinkButton';

import { GpuSummary } from './GpuSummary';
import { useGpuQuery } from './queries/useGpuQuery';

export function GpuSummaryWidget() {
  const environmentId = useEnvironmentId();
  const { data: gpuInfo, isLoading } = useGpuQuery(environmentId, {
    showError: false,
  });

  if (!isLoading && (!gpuInfo || gpuInfo.Summary.GPUNodeCount === 0)) {
    return null;
  }

  return (
    <div className="row">
      <div className="col-sm-12">
        <Widget>
          <WidgetTitle icon={Gpu} title="GPU" />
          <WidgetBody>
            {isLoading ? (
              <div>Loading GPU information...</div>
            ) : (
              gpuInfo && (
                <div className="flex flex-col gap-y-4">
                  <GpuSummary summary={gpuInfo.Summary} />
                  <div>
                    <LinkButton
                      to="kubernetes.gpu"
                      params={{ endpointId: environmentId }}
                      color="secondary"
                      size="small"
                      data-cy="gpu-summary-view-details"
                    >
                      View GPU details
                    </LinkButton>
                  </div>
                </div>
              )
            )}
          </WidgetBody>
        </Widget>
      </div>
    </div>
  );
}
